import { styled } from '@mui/material';
import getColor from 'utils/getColor';

const ErrorMessage = styled('p')`
  position: absolute;
  left: 0;
  font-size: 13px;
  font-weight: 600;
  color: ${getColor('error')};
  line-height: 125%;
  margin: 3px 0 0 0;
`;

export default ErrorMessage;
